import { render } from "./AppointmentSection.vue?vue&type=template&id=711bd2bb&scoped=true"
import script from "./AppointmentSection.vue?vue&type=script&lang=js"
export * from "./AppointmentSection.vue?vue&type=script&lang=js"

import "./AppointmentSection.vue?vue&type=style&index=0&id=711bd2bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711bd2bb"]])

export default __exports__